import { useState, useEffect } from "react";

export const useButtonObserver = (buttonClass) => {
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    const observer = new MutationObserver((mutationsList) => {
      const btn = document.getElementsByClassName(buttonClass);

      if (btn.length > 0) {
        const element = btn[0];

        mutationsList.forEach((mutation) => {
          if (mutation.type === "attributes" && mutation.attributeName === "disabled") {
            setIsDisabled(element.disabled);
          }
          if (mutation.type === "attributes") {
            const hasDisabledAttr = element.hasAttribute("disabled");
            const hasDisabledClass = element.classList.contains("disabled");
            setIsDisabled(hasDisabledAttr || hasDisabledClass);
          }
        });
      }
    });

    const interval = setInterval(() => {
      const btn = document.getElementsByClassName(buttonClass);

      if (btn.length > 0) {
        const element = btn[0];

        const hasDisabledAttr = element.hasAttribute("disabled");
        const hasDisabledClass = element.classList.contains("disabled");

        setIsDisabled(hasDisabledAttr || hasDisabledClass);

        observer.observe(element, {
          attributes: true,
          attributeFilter: ["disabled", "class"],
        });

        clearInterval(interval);
      }
    }, 100);

    return () => {
      clearInterval(interval);
      observer.disconnect();
    };
  }, [buttonClass]);

  return isDisabled;
};